module.exports = __webpack_public_path__ + "media/images/left-8ae612f60a4ec13220e4c04489e0bcc3.png";